// extracted by mini-css-extract-plugin
export var image = "partners-module--image--HvbjW";
export var row = "partners-module--row--7GlfI";
export var sectionHead = "partners-module--sectionHead--HmP6f";
export var sectionPartners = "partners-module--sectionPartners--Pr-xE";
export var sectionTitle = "partners-module--sectionTitle--yHXrN";
export var slideContainer = "partners-module--slideContainer--mdWwg";